/* Component Dependencies */
var dealsTeaserTemplate = require('templates/dealsTeaser.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'dealsTeaser',

  template: {
    'dealsTeaser': dealsTeaserTemplate
  },
  bindEvents: function() {
    var _self = this;

    $(window).on('load', function() {
      _self.restrictDealDescription();      
    });
  },
  /**
  * The function is used to restrict the description of deal tile to 175 characters including spaces
  * @param {void}
  */
  restrictDealDescription: function() {
    var dealInfo, $elm;

    this.$el.find('li').each(function(index) {
      dealInfo = $(this).find('p');
      dealInfo.each(function (index) {
        $elm = $(this);
        if ($elm.text().length > 175) {
          $elm.text($elm.text().substr(0, 175) + '...');
        }
      });
    });
  }
});

